import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Icons } from '../utils/Icons';

export function KebabMenu({ menuItems }: { menuItems: (typeof MenuItem)[] }) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return menuItems ? (
    <div>
      <Button onClick={handleClick} style={{ color: 'black' }}>
        <Typography variant="h6">{Icons.moreVertical}</Typography>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'delete'
        }}
      >
        {menuItems.map((item: any) => item)}
      </Menu>
    </div>
  ) : (
    <div />
  );
}
